module.exports = __webpack_public_path__ + "step4_C2P_okuta_bridal.41f1dc57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_C2P_okuta_bridal.jpg
// module id = GP5V
// module chunks = 0